var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    '__layout',
    { 'is-ie': _vm.isIE }
]},[_c('LayoutHeader'),_c('LayoutMain'),_c('LayoutFooter'),(false)?_c('Devtools'):_vm._e(),_c('Student'),_c('LoaderOverlay',{attrs:{"is-active":_vm.isSiteLoaderActive,"theme":_vm.siteLoaderTheme}}),_c('Cookies')],1)}
var staticRenderFns = []

export { render, staticRenderFns }